module.exports = __webpack_public_path__ + "img/1-1P61ZS23C21.1e4165a8.png";